//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppTags',
  props: ['tags', 'removeTag', 'clearAllTags'],
  data() {
    return {}
  },
  computed: {},
  methods: {
    getDisplayGroupName(tag) {
      if (!tag || !tag.groupName) return '';
      
      if (tag.isChildFilter === true) {
        return 'Sub-category';
      }
      
      const normalized = tag.groupName.toLowerCase().trim();
      switch (normalized) {
        case 'manufacturer':
          return 'Brand';
        case 'parts':
          return 'Category';
        case 'part types':
          return 'Part Type';
        default:
          return tag.groupName;
      }
    },
  }
}
